// 权限码
// https://wrpnn3mat2.feishu.cn/wiki/XDVAwCzxGiHZdlkh9Xzc6wHhnEw
export const PERM = {
  // 以下是题库权限+首页配置权限+用户管理权限等等
  /** 题目列表 */
  SELECT_PROBLEM_LIST: 'select_problem_list',
  /** 修改题目权限 */
  CHANGE_PROBLEM_AUTH: 'change_problem_auth',
  /** 管理题解 */
  SELECT_PROBLEM_SOLUTION_LIST: 'select_problem_solution_list',
  /** 创建题解 */
  CREATE_PROBLEM_SOLUTION: 'create_problem_solution',
  /** 更新题解 */
  UPDATE_PROBLEM_SOLUTION: 'update_problem_solution',
  /** 删除题解 */
  DELETE_PROBLEM_SOLUTION: 'delete_problem_solution',
  /** 创建OJ题 */
  CREATE_OJ_PROBLEM: 'create_oj_problem',
  /** 创建客观题 */
  CREATE_OBJECTIVE_PROBLEM: 'create_objective_problem',
  /** 编辑题目 */
  UPDATE_PROBLEM: 'update_problem',
  /** 删除题目 */
  DELETE_PROBLEM: 'delete_problem',
  /** 题单管理 */
  SELECT_TRAINING_LIST: 'select_training_list',
  /** 创建题单 */
  CREATE_TRAINING: 'create_training',
  /** 修改题单权限 */
  CHANGE_TRAINING_AUTH: 'change_training_auth',
  /** 编辑题单 */
  UPDATE_TRAINING: 'update_training',
  /** 删除题单 */
  DELETE_TRAINING: 'delete_training',
  /** 管理题单中题目 */
  MANAGE_TRAINING: 'manage_training',
  /** 题库管理 */
  SELECT_WAREHOUSE_LIST: 'select_warehouse_list',
  /** 创建题库 */
  CREATE_WAREHOUSE: 'create_warehouse',
  /** 修改题库权限 */
  CHANGE_WAREHOUSE_AUTH: 'change_warehouse_auth',
  /** 编辑题库 */
  UPDATE_WAREHOUSE: 'update_warehouse',
  /** 删除题库 */
  DELETE_WAREHOUSE: 'delete_warehouse',
  /** 管理题库中题目 */
  MANAGE_WAREHOUSE: 'manage_warehouse',
  /** 员工管理 */
  SELECT_USER_LIST: 'select_user_list',
  /** 员工角色编辑 */
  UPDATE_USER_ROLE: 'update_user_role',
  /** banner管理列表 */
  SELECT_BANNER_LIST: 'select_banner_list',
  /** banner上下架管理 */
  PUT_ON_BANNER: 'put_on_banner',
  /** 设置banner序号 */
  SEQUENCE_BANNER: 'sequence_banner',
  /** 创建banner */
  CREATE_BANNER: 'create_banner',
  /** 更新banner */
  UPDATE_BANNER: 'update_banner',
  /** 核桃精选查看 */
  SELECT_DISCUSSION_LIST: 'select_discussion_list',
  /** 核桃精选创建 */
  CREATE_DISCUSSION: 'create_discussion',
  /** 核桃精选修改 */
  UPDATE_DISCUSSION: 'update_discussion',
  /** 核桃精选删除 */
  DELETE_DISCUSSION: 'delete_discussion',
  /** 上传资源 */
  UPLOAD_RESOURCE: 'upload_resource',
  // 以下是比赛权限
  /** 比赛列表查看 */
  SELECT_CONTEST_LIST: 'select_contest_list',
  /** 创建比赛 */
  CREATE_CONTEST: 'create_contest',
  /** 修改比赛 */
  UPDATE_CONTEST: 'update_contest',
  /** 删除比赛 */
  DELETE_CONTEST: 'delete_contest',
  /** 修改比赛权限 */
  CHANGE_CONTEST_AUTH: 'change_contest_auth',
  /** 比赛公告管理-查看比赛公告 */
  GET_CONTEST_ANNOUNCEMENT: 'get_contest_announcement',
  /** 比赛公告管理-管理比赛公告 */
  MANAGE_CONTEST_ANNOUNCEMENT: 'manage_contest_announcement',
  /** 比赛题目管理-查看比赛题目 */
  GET_CONTEST_PROBLEM: 'get_contest_problem',
  /** 比赛题目管理-管理比赛题目 */
  MANAGE_CONTEST_PROBLEM: 'manage_contest_problem',
  /** 比赛题目管理-重测题目 */
  REJUDGE_CONTEST_PROBLEM: 'rejudge_contest_problem',
  /** 比赛全部提交-下载赛中提交/赛后提交 */
  DOWNLOAD_CONTEST_SUBMIT_CODE: 'download_contest_submit_code',
  /** 比赛成绩管理-查看比赛成绩列表 */
  GET_CONTEST_RANK_LIST: 'get_contest_rank_list',
  /** 比赛成绩管理-下载比赛成绩列表 */
  DOWNLOAD_CONTEST_RANK_LIST: 'download_contest_rank_list',
  /** 题单管理-题单全部提交页面 */
  GET_TRAINING_SUBMIT_LIST: 'get_training_submit_list',
  /** 题单管理-题单完成情况查询 */
  SELECT_TRAINING_PROGRESS: 'select_training_progress',
  /** 题单管理-题单完成情况导出 */
  DOWNLOAD_TRAINING_PROGRESS: 'download_training_progress',
  /** 洛谷题导入 */
  IMPORT_LUOGU: 'import_luogu',
  /** 导入重庆8中题目 */
  IMPORT_BECODER: 'import_becoder',
  /** 云桌面管理 */
  SIMULAR_MANAGER: 'simular_manager',
  /** 质量控制-题解审核 */
  QUALITY_CONTROL: 'quality_control',
  /** 标注作弊 */
  MARK_CHEAT: 'mark_cheat',
  /** 获取全部提交 */
  GET_ALL_SUBMIT_LIST: 'get_all_submit_list',
  /** 查看发帖权限白名单 */
  GET_POSTER_USER_LIST: 'get_poster_user_list',
  /** 搜索全部题目 */
  GET_ALL_PROBLEM_LIST: 'get_all_problem_list',
  /** 下载题目 */
  DOWNLOAD_PROBLEM_ZIP: 'download_problem_zip',
  /** 允许没有评论权限的人评论 */
  ALLOW_COMMENT: 'allow_comment',
  /** 跨域复制-前端没用上-后端在用 */
  COPY_CROSS_ZONE: 'copy_cross_zone',
  /** 复制题目-前端没用上-后端在用 */
  COPY_PROBLEM: 'copy_problem',
  /** C端提交记录页面-区分是否可以查询他人提交记录 */
  GET_SUBMISSION_LIST: 'get_submission_list',
  /** 抄袭作弊检测按钮 */
  GET_PLAGIARISM_CHECK: 'get_plagiarism_check',
  /** 查看角色权限 */
  VIEW_ROLE_AUTH: 'view_role_auth',
  /** 编辑角色权限 */
  EDIT_ROLE_AUTH: 'edit_role_auth',
  /** 超管权限 */
  ROOT_AUTH: 'root_auth',

  // 以下是小组权限-开始位置
  /** 小组详情 */
  GET_GROUP: 'get_group',
  /** 小组编辑 */
  MANAGE_GROUP: 'manage_group',
  /** 小组成员管理-查看成员 */
  GET_GROUP_MEMBER: 'get_group_member',
  /** 小组成员管理-管理小组成员 */
  MANAGE_GROUP_MEMBER: 'manage_group_member',
  /** 小组题目管理-查看题目 */
  GET_GROUP_PROBLEM: 'get_group_problem',
  /** 小组题目管理-管理题目 */
  MANAGE_GROUP_PROBLEM: 'manage_group_problem',
  /** 小组题单管理-查看题单 */
  GET_GROUP_TRAINING: 'get_group_training',
  /** 小组题单管理-管理题单 */
  MANAGE_GROUP_TRAINING: 'manage_group_training',
  /** 小组比赛管理-查看比赛 */
  GET_GROUP_CONTEST: 'get_group_contest',
  /** 小组比赛管理-管理比赛 */
  MANAGE_GROUP_CONTEST: 'manage_group_contest',
  /** 查看小组公告 */
  GET_GROUP_ANNOUNCEMENT: 'get_group_announcement',
  /** 小组公告管理-管理公告 */
  MANAGE_GROUP_ANNOUNCEMENT: 'manage_group_announcement',
  /** 小组全部提交 */
  GET_GROUP_SUBMIT_LIST: 'get_group_submit_list',
  /** 小组比赛题目管理-重测题目 */
  REJUDGE_GROUP_CONTEST_PROBLEM: 'rejudge_group_contest_problem',
  /** 小组抄袭作弊检测按钮 */
  GET_GROUP_PLAGIARISM_CHECK: 'get_group_plagiarism_check',
  // 以下是小组权限-结束位置
} as const;

export const PERM_ROOT_AUTH = 'root_auth';

// 组合权限码
// 只要满足一个权限即可
export const PERMS = {
  GROUP_PAGE: [PERM.GET_GROUP, PERM.MANAGE_GROUP],
  GROUP_CONTEST_PAGE: [PERM.GET_GROUP_CONTEST, PERM.MANAGE_GROUP_CONTEST],
  GROUP_PROBLEM_PAGE: [PERM.GET_GROUP_PROBLEM, PERM.MANAGE_GROUP_PROBLEM],
  GROUP_TRAINING_PAGE: [PERM.GET_GROUP_TRAINING, PERM.MANAGE_GROUP_TRAINING],
  GROUP_MEMBER_PAGE: [PERM.GET_GROUP_MEMBER, PERM.MANAGE_GROUP_MEMBER],
  GROUP_ANNOUNCEMENT_PAGE: [
    PERM.GET_GROUP_ANNOUNCEMENT,
    PERM.MANAGE_GROUP_ANNOUNCEMENT,
  ],
  CREATE_ALL: [
    PERM.CREATE_WAREHOUSE,
    PERM.CREATE_TRAINING,
    PERM.CREATE_CONTEST,
    PERM.MANAGE_GROUP,
  ],
  INDEX_CONFIG: [PERM.SELECT_DISCUSSION_LIST, PERM.SELECT_BANNER_LIST],
  SELECT_TAG_LIST: [
    PERM.CREATE_OJ_PROBLEM,
    PERM.CREATE_OBJECTIVE_PROBLEM,
    PERM.UPDATE_PROBLEM,
  ],
};

export const SUPER_ADMIN_ROLE = 1006;
